module.exports = __webpack_public_path__ + "static/comune.4e28cd30.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/comune.jpg
// module id = 1613
// module chunks = 35783957827783